import type { FontSchemaType } from "../font";
/* -----------------Types--------------- */
import Box from "./Box";
import TooltipWrapper from "./TooltipWrapper";

/* -----------------Child components--------------- */
import { Chip } from "react-native-paper";
import { CustomListSubheader } from "./CustomListSubheader";

type Props = {
	tags: string[];
	appFont?: FontSchemaType;
};
export const TagsList = ({ tags, appFont }: Props) => {
	return (
		<Box>
			<CustomListSubheader
				enableGutters={false}
				font={appFont}
				textVariant="titleMedium"
				dense
			>
				Tags
			</CustomListSubheader>
			<Box gap={8} flexDirection="row" flexWrap="wrap">
				{tags.map((tag, index) => {
					if (tag && tag.length > 35) {
						return (
							<TooltipWrapper key={tag} title={tag}>
								<Chip
									style={{
										maxWidth: 300,
									}}
									testID={`tag-${index + 1}`}
								>
									{tag}
								</Chip>
							</TooltipWrapper>
						);
					}
					return (
						<Chip
							key={tag}
							style={{
								maxWidth: 300,
							}}
						>
							{tag}
						</Chip>
					);
				})}
			</Box>
		</Box>
	);
};
